// Utils
import cntl from "cntl";

// Icon
import { IconLoader2 } from "@tabler/icons-react";

const FullScreenLoader = () => {
  const fullScreenLoaderCn = () => cntl`
    flex
    h-screen
    items-center
    backdrop-blur
    justify-center
    bg-gray-light-6
    dark:bg-gray-dark-6
  `;

const iconCn = () => cntl`
    w-[5.5rem]
    h-[5.5rem]
    animate-spin
    text-primary-light-9
    dark:text-primary-dark-9
  `;

  return (
    <div className={fullScreenLoaderCn()}>
      <IconLoader2 className={iconCn()} />
    </div>
  );
};

export default FullScreenLoader;
